<template>
  <div>
    <modal-vue class="col-lg-12" v-if="existNotRead()">
      <div slot="header">
        <h3>Avisos</h3>
      </div>

      <div slot="body" style="margin: 0px; overflow: auto; height: 300px">
        <ul class="topics-list">
          <li class="topic" v-for="alert in alertList" :key="alert.id">
            <div class="topic-description-bar" v-if="!alert.read">
              <span
                >Enviado por: {{ alert.userName }} em:
                {{ getDate(alert.creationDate) }}
                {{
                  alert.productName != null
                    ? " - " +
                      alert.productName.slice(0, 25) +
                      (alert.productName.length > 25 ? "..." : "")
                    : ""
                }}</span
              >
            </div>
            <div class="topic-title-bar" v-if="!alert.read">
              <div class="text-content">
                <h5
                  v-if="alert.text.length < 262"
                  class="cropped-text"
                  style="font-size: 14px"
                  v-html="alert.text"
                > {{alert.text}}
                </h5>

                <h5
                  v-else
                  class="cropped-text"
                  style="font-size: 14px"
                  v-html="alert.text">
                   {{alert.text}}
                </h5>
              </div>
            </div>

            <lms-button
              v-if="!alert.read"
              :disabled="saving"
              @click="save(alert)"
              :loading="saving"
              >Marcar como lido</lms-button
            >
          </li>
        </ul>
      </div>

      <div slot="footer">
        <lms-button
          :disabled="false"
          @click="close()"
          class="btn-danger"
          :loading="false"
          >Lembrar mais tarde</lms-button
        >
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  props: ["alertList"],
  data() {
    return {
      saving: false,
      alert: {},
      userType: this.$store.getters.user.type,
    };
  },
  methods: {
    convertURLs(text){
        let links = text.match(/(https?:\/\/|)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g);
        links.forEach((el, index, array) => {
          if(el != '/' && el != undefined && el != '' && el != 'http://' && el != 'https://'){
            text = text.replace(el, `{el${index}}`);
          }
        });
        links.forEach((el, index, array) => {
          text = text.replaceAll(`{el${index}}`, '<a href=' + (el.startsWith('http://') || el.startsWith('https://') ? el : 'http://' + el ) + ' target="_blank">' + el + '</a>');
        });
        return text;
    },
    save(alert) {
      console.log("salvando o alerta");
      this.saving = true;
      const path = this.$global.endpoint + "/user/message/markread";
      axios
        .post(path, {
          alert: alert,
        })
        .then((res) => {
          for (let i = 0; i < this.alertList.length; i++) {
            if (this.alertList[i].id == alert.id) {
              this.alertList[i].read = true;
            }
          }
          this.saving = false;
          this.$emit("markedRead");
        })
        .catch((error) => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error,
          });
        });
    },
    close() {
      console.log("alertList.length", this.alertList[0]);
      this.$emit("close");
    },
    existNotRead() {
      for (let i = 0; i < this.alertList.length; i++) {
        if (!this.alertList[i].read) {
          return true;
        }
      }

      return false;
    },
    getDate(date) {
      let d = new Date(new Date(date).setHours(new Date(date).getHours() - 3));
      d = `${d.getDate() < 10 ? "0" + d.getDate() : d.getDate()}/${
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1
      }/${d.getFullYear()} ${
        d.getHours() < 10 ? "0" + d.getHours() : d.getHours()
      }:${d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes()}`;
      return d;
    },
  },
  created() {

  },
   mounted() {

     this.alertList.forEach((el, index, array) => {
        this.alertList[index].text = this.convertURLs(this.alertList[index].text);
     });
      // this.alert.text = this.convertURLs();
  //   transformed () {
  //     const template = this.convertURLs(this.alet.text);
  //     return {
  //       template: template,
  //       props: this.$options.props
  //     }
  //   }
  }
};
</script>
